import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import ProgressBar from 'ui/elements/ProgressBar'
import { observer } from 'mobx-react'
import { useTranslation } from '@morningtrain/react-translations'

function ScheduleDayProgressBar (props) {
  const activeCategory = useValue('category')
  const usedCostDistributionKitchen = useValue('used_cost_distribution_kitchen')
  const usedCostDistributionWaiter = useValue('used_cost_distribution_waiter')

  const ratioDistribution = activeCategory === 'kitchen' ? usedCostDistributionKitchen : usedCostDistributionWaiter
  const otherRatioDistribution = activeCategory === 'waiter' ? usedCostDistributionKitchen : usedCostDistributionWaiter

  const kitchenUsageTrans = useTranslation('generic.kitchen_usage')
  const waiterUsageTrans = useTranslation('generic.waiter_usage')

  const labelTrans = activeCategory === 'kitchen' ? kitchenUsageTrans : waiterUsageTrans
  const otherLabelTrans = activeCategory === 'waiter' ? kitchenUsageTrans : waiterUsageTrans

  return (
    <>
      <ProgressBar
        classNames={['mt-4']}
        middleIndicator
        progress={[
          { color: 'bg-lines', progress: otherRatioDistribution * 100, label: otherLabelTrans },
          { color: 'bg-primary-500', progress: ratioDistribution * 100, label: labelTrans }]}
      />
    </>
  )
}

ScheduleDayProgressBar.defaultProps = {
  weekDay: null
}

export default observer(ScheduleDayProgressBar)
